<app-standard-bottom-sheet [isOpen]="isOpen()"
                          [isFullScreen]="true"
                          (isOpenChange)="onSheetOpenChange($event)"
                          testId="checklist-issues-sheet">

  <app-section-header title="Logged Issues"
                      align="center"
                      testId="checklist-issues-sheet" />

  <div class="checklist-issues-body">
    <p class="assertion-text"
       [innerHTML]="assertionText()"
       data-testid="checklist-issues-sheet-text-assertion"></p>

    @for (entry of issues(); track entry.issue.identifier; let index = $index) {
      <article class="logged-issue"
               [attr.aria-label]="'Issue ' + (index + 1)"
               [attr.data-testid]="'checklist-issues-sheet-issue-' + entry.issue.id">
        <header class="logged-issue-header">
          <p class="logged-issue-title"
             [attr.data-testid]="'checklist-issues-sheet-text-' + entry.issue.id">{{ entry.issue.text }}</p>

          <div class="logged-issue-actions">
            <p-button icon="pi pi-pen-to-square"
                      type="button"
                      severity="secondary"
                      [text]="true"
                      [disabled]="busy()"
                      [ariaLabel]="'Edit issue ' + (index + 1)"
                      styleClass="bqa-secondary-btn"
                      (click)="editRequested.emit(entry.issue)"
                      [attr.data-testid]="'checklist-issues-sheet-btn-edit-' + entry.issue.id" />
          </div>
        </header>
        <div class="logged-issue-photos">
          <app-photo-capture-button [ariaLabel]="'Add photos to issue ' + (index + 1)"
                                    source="library"
                                    [disabled]="busy()"
                                    [inputId]="'checklist-issues-sheet-photo-' + entry.issue.id"
                                    (filesSelected)="onPhotosSelected(entry.issue, $event)"
                                    [testId]="'checklist-issues-sheet-btn-photo-' + entry.issue.id" />
          @if (entry.media.length > 0) {
            <app-assertion-image-gallery [images]="entry.media"
                                         [readonly]="true"
                                         [thumbnailSize]="64"
                                         [maxThumbnails]="2" />
          }
        </div>
      </article>
    } @empty {
      <p class="logged-issue-empty"
         data-testid="checklist-issues-sheet-empty">No issues have been logged for this item.</p>
    }
  </div>

  <app-vertical-button-group [buttons]="footerButtons"
                             testId="checklist-issues-sheet-footer" />
</app-standard-bottom-sheet>
